export function LogoMark({ size = 40, className = "" }) {
  return (
    <img
      src="/logo-sm.webp"
      alt="Logo Motards Business Club 84"
      width={size}
      height={size}
      className={`rounded-full ring-1 ring-gold/50 shadow-[0_0_18px_rgba(212,175,55,0.25)] ${className}`}
      style={{ width: size, height: size }}
    />
  );
}

export default function Logo({ size = 40, compact = false }) {
  return (
    <span className="inline-flex items-center gap-3">
      <LogoMark size={size} />
      <span className="flex flex-col leading-none">
        <span className="font-heading font-extrabold tracking-tight text-foreground" style={{ fontSize: size * 0.42 }}>
          MBC<span className="text-gold-grad">84</span>
        </span>
        {!compact && (
          <span className="font-mono uppercase text-muted-foreground" style={{ fontSize: Math.max(7, size * 0.16), letterSpacing: "0.22em", marginTop: 4 }}>
            Motards Business Club
          </span>
        )}
      </span>
    </span>
  );
}
